import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { ConcessionDashboardStats } from '../../lib/api';
import { RISK_LEVEL_COLORS, DEVIATION_TYPE_LABELS } from './constants';

interface BreakdownCardsProps {
  stats: ConcessionDashboardStats | null;
}

export function BreakdownCards({ stats }: BreakdownCardsProps) {
  const getRiskBadge = (riskLevel: string) => {
    const config = RISK_LEVEL_COLORS[riskLevel];
    const label = config?.label || riskLevel;
    const className = config?.className || 'bg-transparent !text-black border-gray-300';
    return <Badge variant="outline" className={className}>{label}</Badge>;
  };

  const hasRiskLevels = stats?.by_risk_level && Object.keys(stats.by_risk_level).length > 0;
  const hasDeviationTypes = stats?.by_deviation_type && Object.keys(stats.by_deviation_type).length > 0;

  if (!hasRiskLevels && !hasDeviationTypes) {
    return null;
  }

  return (
    <div className="grid gap-4 md:grid-cols-2">
      {hasRiskLevels && (
        <Card>
          <CardHeader>
            <CardTitle>By Risk Level</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {Object.entries(stats!.by_risk_level).map(([level, count]) => (
                <div key={level} className="flex items-center justify-between">
                  {getRiskBadge(level)}
                  <span className="text-lg font-semibold">{count}</span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {hasDeviationTypes && (
        <Card>
          <CardHeader>
            <CardTitle>By Deviation Type</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {Object.entries(stats!.by_deviation_type).map(([type, count]) => (
                <div key={type} className="flex items-center justify-between">
                  <span className="text-sm font-medium">{DEVIATION_TYPE_LABELS[type] || type}</span>
                  <span className="text-lg font-semibold">{count}</span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
